import { render, staticRenderFns } from "./RegistroMovimientoArmaDialogComponent.vue?vue&type=template&id=58559244&scoped=true"
import script from "./RegistroMovimientoArmaDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroMovimientoArmaDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./RegistroMovimientoArmaDialogComponent.vue?vue&type=style&index=0&id=58559244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58559244",
  null
  
)

export default component.exports